// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { autoDeliveryActionsStyles } from "@guestsupply/App/Widgets/AutoDelivery/AutoDeliveryActions";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { RadioStyle } from "@insite/mobius/Radio";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

autoDeliveryActionsStyles.autoDeliveryActionsGridContainer = {
    offsetCss: css`
        &&& {
            ${xScreen("lte", "md")} {
                margin-top: 20px;
            }
        }
    `,
};
autoDeliveryActionsStyles.autoDeliveryActionsGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        margin-top: 20px;
    `,
};
autoDeliveryActionsStyles.autoDeliveryTypeLabel = {
    ...xOrderInformationStyles.address?.heading,
};
autoDeliveryActionsStyles.autoDeliveryTypeRadioGroup = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: block;
                        margin-top: 10px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: block;
                        margin-top: 10px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
            ])}
    `,
};

autoDeliveryActionsStyles.divider = {
    ...xOrderInformationStyles.address?.divider,
};
